
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.889 9.003c-3.425.195-10.233.902-14.435 3.475a.96.96 0 00-.455.823v22.742c0 .722.79 1.178 1.455.843 4.324-2.176 10.577-2.77 13.669-2.933 1.056-.055 1.876-.902 1.876-1.916V10.922c0-1.107-.96-1.984-2.11-1.919zm-17.343 3.475c-4.202-2.573-11.01-3.28-14.435-3.475C6.96 8.938 6 9.815 6 10.923v21.115c0 1.015.82 1.86 1.876 1.916 3.093.162 9.35.757 13.673 2.934.664.335 1.45-.121 1.45-.841V13.29a.94.94 0 00-.453-.812z","fill":"#535353"}})])
          )
        }
      }
    